export enum InscripcionEstado {
  inscrito = "INSCRITO",
  finalizado = "FINALIZADO",
  cancelado = "CANCELADO",
  abandono = "ABANDONO",
  listaDeEspera = "LISTA_DE_ESPERA",
}
